import { CommandeLinePanier } from '../commandeLine/commandeLine.def';
import { FraisPortInput } from '../../graphql/generated/graphql';
import pages from '../../routes/pages';

export interface RemoveLineTypes {
  lineToRemove: number;
  totalLine: number;
}

export interface UpdateContributionOng {
  contributionOng: number;
}

export interface PanierState {
  totalPanier: number;
  contributionOng: {
    isContributing: boolean;
    amount: number;
  };
  fraisPort: FraisPortInput;
  commandeLines: CommandeLinePanier[];
}

export const initialFraisPort: FraisPortInput = {
  applicable: false,
  montant: 0
};

export const isPanierPage = (currentLocation: string) =>
  currentLocation === pages.PANIER_PAGE.path;
